import { render } from "./appuntamentoModal.vue?vue&type=template&id=fb61a7e2&scoped=true&ts=true"
import script from "./appuntamentoModal.vue?vue&type=script&lang=ts"
export * from "./appuntamentoModal.vue?vue&type=script&lang=ts"

import "./appuntamentoModal.vue?vue&type=style&index=0&id=fb61a7e2&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb61a7e2"]])

export default __exports__